import React, { useEffect } from "react";
import { Link } from "react-router-dom";

const Klokbox = () => {
  useEffect(() => {
    // App carousel slider
    const slider = document.getElementById("slider");
    if (!slider) return;

    let currentIndex = 0;
    const slides = slider.children;
    const totalSlides = slides.length;

    const slide = () => {
      if (totalSlides > 0) {
        currentIndex = (currentIndex + 1) % (totalSlides - 2);
        slider.style.transform = `translateX(-${currentIndex * 33.333}%)`;
      }
    };

    const slideInterval = setInterval(slide, 3000);

    return () => {
      clearInterval(slideInterval);
    };
  }, []);

  return (
    <div className="klokbox-page portfolio-details-page">
      <section className="banner-section">
        <div className="intro">
          <div className="intro-bg wow fadeIn" data-wow-delay="0.3s">
            <img
              src="/assets/images/background/intro-bg.jpg"
              alt="Light Background"
            />
          </div>
          <div className="container wow fadeIn" data-wow-delay="0.3s">
            <h1>
              <img src="/assets/images/logos/logo-klokkbox.svg" alt="klokbox" />
            </h1>
            <h2>Secure Estate Planning</h2>
            <div className="breadcrumb">
              <span>
                Portfolio / <strong>Klokbox</strong>
              </span>
            </div>
          </div>
        </div>
      </section>

      <section className="whatwedo-section">
        <div className="container">
          <div className="row">
            <div className="col col-4">
              <h2>What We Did</h2>
              <ul className="list">
                <li>Product Architecture</li>
                <li>Mobile Development</li>
                <li>Web Development</li>
                <li>Backend Development</li>
                <li>Security</li>
              </ul>
            </div>
            <div className="col col-8">
              <h2>Overview</h2>
              <p>
                Klokbox is a revolutionary web and mobile app that offers a
                secure and user-friendly platform for estate planning. It is
                designed to resolve property disputes that frequently arise
                after a sudden death. The app provides three key features:
                secure will writing, password and business secret storage, and
                funeral planning, allowing users to document their last wishes
                and memories.
              </p>
              <p>
                The Irish Government has entrusted Klokbox with the critical
                task of addressing property disputes arising from sudden deaths.
                The app offers users the ability to write a secure will,
                ensuring their property is distributed according to their
                wishes. The app also provides a secure space for users to store
                important business information and passwords, ensuring that
                their digital assets are secure. Additionally, Klokbox offers a
                feature to plan for funeral wishes and record memories,
                providing peace of mind to users and their loved ones.
              </p>
            </div>
          </div>
          <div className="portfolio-carousel">
            <div className="slide-content">
              <img
                src="/assets/images/background/klockbox/main.png"
                alt="klockbox"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="challenges-section">
        <div className="container">
          <div className="challenges">
            <div className="col col-6">
              <div className="img-card">
                <img
                  src="/assets/images/background/klockbox/main-1.webp"
                  alt="klockbox-3"
                />
              </div>
            </div>
            <div className="col col-6">
              <div className="info-card">
                <h3>Challenges</h3>
                <div className="scroll">
                  <p>
                    Klokbox faced significant challenges with their initial
                    software team, as the project suffered from scalability and
                    security issues. As a result, they sought to rebuild the
                    platform with us from the ground up to better address the
                    needs of their users.
                  </p>
                  <p>
                    Klokbox had a crucial requirement of ensuring the project's
                    compliance with HIPAA and GDPR regulations.
                  </p>
                  <p>
                    One of the primary concerns was creating a highly secure
                    platform that could protect sensitive user data from leaks
                    before their death. Client wanted to explore solutions that
                    could improve the app's functionality and user experience.
                    Furthermore, they needed to ensure that the platform was
                    scalable enough to handle multiple concurrent users.
                  </p>
                </div>
              </div>
            </div>
            <div className="col col-6 flex-reverse">
              <div className="img-card">
                <img
                  src="/assets/images/background/klockbox/main-2.webp"
                  alt="klockbox-4"
                />
              </div>
            </div>
            <div className="col col-6">
              <div className="info-card">
                <h3>Solutions</h3>
                <div className="scroll">
                  <p>
                    Our team successfully overcame the challenges by
                    implementing a range of solutions. To ensure the security of
                    the platform, they used encryption for both data storage and
                    server communication. They also utilized Terraform to
                    restrict user data from the development team and deployed it
                    securely, making sure it followed HIPPA and GDPR compliance.
                  </p>
                  <p>
                    To prevent data leaks, all sensitive information was
                    encrypted using advanced encryption algorithms, and calls to
                    the server were encrypted using SSL/TLS protocols. The
                    platform was also designed to be scalable, allowing for
                    multiple concurrent users to access it seamlessly.
                  </p>
                  <p>
                    In addition to the above, the team found solutions that
                    improved some of the app's functionalities. This included
                    the implementation of more efficient algorithms for data
                    processing, enabling faster retrieval of information.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="app-section">
        <div className="container">
          <div className="title">
            <h2>Browse on any device</h2>
            <p>
              Experience responsive, pixel-perfect UI designs on any device with
              our custom software solutions
            </p>
          </div>
          <div className="app-carousel" id="slider">
            <div className="slide-content">
              <img
                src="/assets/images/background/klockbox/s1.webp"
                alt="klockbox-5"
              />
            </div>
            <div className="slide-content">
              <img
                src="/assets/images/background/klockbox/s2.webp"
                alt="klockbox-6"
              />
            </div>
            <div className="slide-content">
              <img
                src="/assets/images/background/klockbox/s3.webp"
                alt="klockbox-7"
              />
            </div>
            <div className="slide-content">
              <img
                src="/assets/images/background/klockbox/s4.webp"
                alt="klockbox-8"
              />
            </div>
            <div className="slide-content">
              <img
                src="/assets/images/background/klockbox/s5.webp"
                alt="klockbox-9"
              />
            </div>
            <div className="slide-content">
              <img
                src="/assets/images/background/klockbox/s6.webp"
                alt="klockbox-10"
              />
            </div>
          </div>
          <div className="download-app">
            <h2>Test Drive our Results</h2>
            <p>Experience the impact of our work firsthand</p>
            <div className="app-link">
              <a
                href="https://apps.apple.com/app/klokbox-life-plan-memory-box/id1611328703"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="/assets/images/logos/logo-appstore.png"
                  alt="appstore"
                />
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=com.klokbox"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="/assets/images/logos/logo-playstore.png"
                  alt="playstore"
                />
              </a>
              <a
                href="https://klokbox.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src="/assets/images/logos/logo-website.png" alt="logo" />
              </a>
            </div>
          </div>
        </div>
      </section>

      <section className="testimonial-section">
        <div className="container">
          <div className="testimonial-carousel">
            <div className="slide-content">
              <div className="slide-info">
                <h3>
                  Working with Slash Star on our secure memory box platform,
                  Klokbox, has been an outstanding experience. They delivered a
                  top-notch app, ensuring data integrity and GDPR compliance.
                  Their expertise in data security and cloud integration, along
                  with their professionalism and commitment to quality, make
                  them the perfect choice for any app development project.
                </h3>
                <div className="flex">
                  <div className="client flex">
                    <div className="client-img">
                      <img
                        src="/assets/images/reviews/klokbox/user.jpg"
                        alt="client"
                      />
                    </div>
                    <div className="client-details">
                      <h4>Daniel Culloty</h4>
                      <h5>CEO, Klokbox</h5>
                    </div>
                  </div>
                  <div className="logo-img grayscale">
                    <img
                      src="/assets/images/logos/logo-klokbox-1.svg"
                      alt="klokbox"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="portfolio-section projects-section">
        <div className="container">
          <h2>More Projects</h2>
          <div className="portfolio card-deck-js">
            <div className="portfolio-card">
              <Link to="/finutss">
                <div className="portfolio-product">
                  <div className="product-image">
                    <img
                      src="/assets/images/protfolio/finutz.svg"
                      alt="Finutss"
                    />
                  </div>
                  <div className="product-content">
                    <div className="product-data">
                      <h3>Finutss</h3>
                      <div>
                        <span>iOS</span>
                        <span>Android</span>
                      </div>
                    </div>
                    <div className="product-url">
                      <img src="/assets/images/icon/arrow.svg" alt="arrow-1" />
                    </div>
                  </div>
                </div>
              </Link>
              <Link to="/bullz">
                <div className="portfolio-product">
                  <div className="product-image">
                    <img src="/assets/images/protfolio/bullz.svg" alt="bullz" />
                  </div>
                  <div className="product-content">
                    <div className="product-data">
                      <h3>Bullz</h3>
                      <div>
                        <span>iOS</span>
                        <span>Android</span>
                      </div>
                    </div>
                    <div className="product-url">
                      <img src="/assets/images/icon/arrow.svg" alt="arrow-2" />
                    </div>
                  </div>
                </div>
              </Link>
              <Link to="/telly">
                <div className="portfolio-product">
                  <div className="product-image">
                    <img src="/assets/images/protfolio/telly.svg" alt="Telly" />
                  </div>
                  <div className="product-content">
                    <div className="product-data">
                      <h3>Telly</h3>
                      <div>
                        <span>Web</span>
                        <span>iOS</span>
                        <span>Android</span>
                      </div>
                    </div>
                    <div className="product-url">
                      <img src="/assets/images/icon/arrow.svg" alt="arrow-3" />
                    </div>
                  </div>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Klokbox;
